import { ecsApi } from '@services';
import { LoginRequest, LoginResponse, RegisterFcmTokenRequest } from './auth.types';

export const authApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<LoginResponse, LoginRequest>({
            query: (credentials) => ({
                url: '/users/login',
                method: 'POST',
                body: credentials
            })
        }),
        /**
         * Enregistre le token FCM independamment de la connexion.
         *
         * Sur une installation neuve le token n'existe pas encore au moment du
         * login : le shell natif doit d'abord obtenir l'autorisation, s'enregistrer
         * aupres d'APNs, puis attendre que Firebase l'emette. Sans ce point
         * d'entree, la colonne restait vide jusqu'a la connexion suivante.
         */
        registerFcmToken: builder.mutation<unknown, RegisterFcmTokenRequest>({
            query: (body) => ({
                url: '/users/fcm-token',
                method: 'POST',
                body
            })
        })
    })
});

export const { useLoginMutation, useRegisterFcmTokenMutation } = authApi;
